// ReturnProductStoreApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'ReturnVendorProducts'];

// Enhance the base API service by adding entication-related tag types
const ReturnProductStoreApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Create a new 
        createReturnVendorProducts: build.mutation({
            query: ({ user_id,Product_id }) => ({
              url: `/Return_Vendor_Products_store/${user_id}/${Product_id}`,
              method: 'POST',
              data:{}, // Send an empty object
            }),
            invalidatesTags: ['ReturnVendorProducts'],  // Invalidate ShopProfiles tags after creation
          }),
          
      // Fetch ReturnVendorProducts query (GET request to /me)
      getReturnVendorProductsByUser: build.query({
        query: (userId) => ({
          url: `/Return_Vendor_Products_store/user/${userId}`,
        }),
        providesTags: ['ReturnVendorProducts'],
      }),  

      getPaginatedReturnVendorProducts: build.query({
        query: ({ page, size, sort, productName, categoryId, subCategoryId }) => {
          const params = new URLSearchParams();
      
          // Required parameters
          params.append('page', page);
          params.append('size', size);
      
          // Optional parameters
          if (sort) {
            if (Array.isArray(sort) && sort.length === 2) {
              // Join the sort field and order as "id,desc"
              params.append('sort', `${sort[0]},${sort[1]}`);
            } else if (Array.isArray(sort)) {
              // Handle multiple sort parameters (e.g., ["id,desc", "name,asc"])
              params.append('sort', sort.join(','));
            } else {
              // Handle single sort parameter (e.g., "id,desc")
              params.append('sort', sort);
            }
          }
      
          if (productName) params.append('productName', productName); // Ensure the parameter name matches the backend
          if (categoryId) params.append('categoryId', categoryId);
          if (subCategoryId) params.append('subCategoryId', subCategoryId);
      
          return {
            url: '/Return_Vendor_Products_store/paginatedReturnedProduct',
            params,
          };
        },
        providesTags: ['ReturnVendorProducts'],
      }),  

      
       // Fetch ReturnVendorProducts query (GET request to /me)
       getReturnVendorProducts: build.query({
        query: () => ({
          url: `/Return_Vendor_Products_store`,
        }),
        providesTags: ['ReturnVendorProducts'],
      }),  
       // Delete   mutation (DELETE request  )
       deleteReturnVendorProducts: build.mutation({
        query: (id) => ({
          url: `Return_Vendor_Products_store/${id}`,
          method: 'DELETE',
        }), 
        invalidatesTags: ['ReturnVendorProducts'], // Invalidate the user tag after deletion
      }),
    }),
    overrideExisting: false,
  });

export default ReturnProductStoreApi;

// Exporting hooks for each endpoint to be used in components
export const {
    useCreateReturnVendorProductsMutation,
    useGetReturnVendorProductsByUserQuery,
   useGetReturnVendorProductsQuery,
   useDeleteReturnVendorProductsMutation,
   useGetPaginatedReturnVendorProductsQuery,
} = ReturnProductStoreApi;

